import { render, staticRenderFns } from "./DrawingRectCanvas.vue?vue&type=template&id=d1541cdc&scoped=true&"
import script from "./DrawingRectCanvas.vue?vue&type=script&lang=js&"
export * from "./DrawingRectCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DrawingRectCanvas.vue?vue&type=style&index=0&id=d1541cdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1541cdc",
  null
  
)

export default component.exports